import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	BIN_LOCATION_REQUEST,
	BIN_LOCATION_CREATE,
	BIN_LOCATION_DELETE,
	BIN_LOCATION_EDIT,
	BIN_LOCATION_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const BinLocation = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchBinLocation,
	submitBinLocationCreate,
	submitBinLocationDelete,
	submitBinLocationEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteBinLocationId, setDeleteBinLocationId] = useState('');
	const [editBinLocationId, setEditBinLocationId] = useState('');
	const [editBinLocationName, setEditBinLocationName] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchBinLocation(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("Bin Location Created Successfully.");
			fetchBinLocation(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("Bin Location Deleted Successfully.");
			fetchBinLocation(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("Bin Location Data Updated Successfully.");
			fetchBinLocation(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create age demographic create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("Bin Location name cannot be empty.");
		} else {
			submitBinLocationCreate({
				"data": {
					"BinLocationName": inputVal,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteBinLocationId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteBinLocationId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete age demographic delete api
	const handleConfirmDeleteSubmit = () => {
		submitBinLocationDelete({
			"BinLocationId": deleteBinLocationId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditBinLocationId(data.binLocationId);
		setEditBinLocationName(data.binLocationName);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editBinLocationName === '') {
			toast.error("Bin Location name cannot be empty.");
		} else {
			submitBinLocationEdit({
				"data": {
					"BinLocationId": data.binLocationId,
					"BinLocationName": editBinLocationName,
				},
				"token": auth[0].token
			});
			setEditBinLocationId('');
			setEditBinLocationName('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">
					<div className="sub-header mt-5 mb-3">
						<h2>Bin Location</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`Bin Location`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>Bin Location</th>
								<th width="50">Delete</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editBinLocationId === item.binLocationId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editBinLocationName} onChange={(evt) => setEditBinLocationName(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.binLocationName}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`Bin Location`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.binLocationId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	);
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchBinLocation: (token) => dispatch({ type: BIN_LOCATION_REQUEST, token }),
		submitBinLocationCreate: (data) => dispatch({ type: BIN_LOCATION_CREATE, payload: data }),
		submitBinLocationDelete: (data) => dispatch({ type: BIN_LOCATION_DELETE, payload: data }),
		submitBinLocationEdit: (data) => dispatch({ type: BIN_LOCATION_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: BIN_LOCATION_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(BinLocation);